import { Variant } from "lib/enum";

export interface IAppPath {
	Home: string;
	Upload: string;
	Download: string;
	UserManagement: string;
	EmailNotificationSettings: string;
	MCCAccessContactInfo: string;
	Permissions: string;
}

export class AppPath extends Variant<IAppPath> {
	Path() {
		return this.Data;
	}
	static Home() {
		return AppPath.New("Home", "/");
	}

	static Upload() {
		return AppPath.New("Upload", "/upload/:id?");
	}

	static Download() {
		return AppPath.New("Download", "/download/:id");
	}

	static UserManagement() {
		return AppPath.New("UserManagement", "/users/:id?");
	}

	static EmailNotificationSettings() {
		return AppPath.New(
			"EmailNotificationSettings",
			"/emailnotificationsettings"
		);
	}

	static MCCAccessContactInfo() {
		return AppPath.New("MCCAccessContactInfo", "/mcc-access-contact-info");
	}

	static Permissions() {
		return AppPath.New("Permissions", "/permissions");
	}
}

export const Home = AppPath.Home;
export const Upload = AppPath.Upload;
export const Download = AppPath.Download;
export const UserManagement = AppPath.UserManagement;
export const EmailNotificationSettings = AppPath.EmailNotificationSettings;
export const MCCAccessContactInfo = AppPath.MCCAccessContactInfo;
export const Permissions = AppPath.Permissions;
